import React from 'react';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/custom/DisplayLongDescriptionAndVariantMFRName';
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useProductStore } from 'src/hooks/product';

const PriceMisMatch = (props) => {
    const { SetStatus } = props
    const { single_product, PRODUCT_PRICE } = props.data;
    const [{ }, { }, { ADD_TO_CART }] = useCartStore();
    const [{ }, { get_end_customer_by_cpn }, { }] = useProductStore();

    const onHide = ( ) => {
        SetStatus(false)
    };

    const updateQty = async () => {
        const v = single_product;
        let param = {
            "partNumber": v.ERPPartNumber,
            "assetURL": v.assetURL,
            "ItemNumber": v.ItemNumber,
            "ManufacturerPartNumber": v.ManufacturerPartNumber,
            "ERPMFRPartNumber": v.ERPMFRPartNumber,
            "quantity": PRODUCT_PRICE.quantity,
            "totalQuantity": v.totalQuantity, //added
            "backOrderedQuantity": v.backOrderedQuantity,
            "subtotal": v.subtotal,
            "manufacturerCode": v.ManufacturerCode,
            "manufacturerName": v.ManufacturerName,
            "erpManufacturerCode": v.ERPManufacturerCode,
            "erpManufacturerName": v.ERPManufacturerName,
            "cpn": v.cpn,
            "default_plant": v.default_plant,
            "mdmMaterialId": v.MDMMaterialID,
            "endCustAccNum": get_end_customer_by_cpn(v.CustomerPartNumbers, v.cpn),
            'isSoftwareDownloadable': v?.SoftwareDownloadFlag,
            'seoerpmfrPartNumber': v?.SEOERPMFRPartNumber,
            'seoManufacturerName': v?.SEOManufacturerName
        }

        await ADD_TO_CART(param, props.data.isManuallyAddCart)

        if (props.data.productAddedToCartCallback) {
            props.data.productAddedToCartCallback();
        }
        if (props.data?.isFrom) {
            System.setEvars(v?.ERPMFRPartNumber, "Add to Cart clicked from " + props.data?.isFrom)
        }

        onHide(false);
    }

    return (
        <div className="avnet-modal modal-680">
            <div className="avnet-modal-inner">
                {/* Modal Header */}
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => { onHide() }}>×
                    </button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading">Price Mismatch Alert</h3>
                </div>
                <div className="m-4 mt-0">
                    <div className="justify-content-start">
                        There is a mismatch between selected Quantity and the available price tier. Please contact your local sales officer for a lower quantity pricing or confirm the adjusted quantity by clicking the Yes button below.
                        </div>
                </div>
                <div className="modal-body">
                    <div className="inventory-table">
                        <table className="table table-outline rounded-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="border-0 text-none font-12">Product(s)</th>
                                    <th className="border-0 text-none font-12">Requested Qty</th>
                                    <th className="border-0 text-none font-12">Adjusted Qty</th>
                                    <th className="border-0 text-none font-12">Unit Price</th>
                                </tr>
                            </thead>
                            <tbody className="border-top-0">

                                <tr>
                                    <td className="align-middle">
                                        <div className="inventory-product-info">
                                            <div className="inventory-product-name">
                                                <NavigateToProductDetail data={{ SEOManufacturerName: single_product?.SEOManufacturerName, SEOERPMFRPartNumber: single_product?.SEOERPMFRPartNumber, ItemNumber: single_product?.ItemNumber, ERPPartNumber: single_product?.ERPPartNumber }}>
                                                    <b className='text-black'>{single_product.ERPMFRPartNumber}</b>
                                                </NavigateToProductDetail>
                                            </div>
                                            <div className="inventory-product-by">
                                                <DisplayLongDescriptionAndVariantMFRName
                                                    currentProduct={{ ManufacturerName: single_product?.ManufacturerName, ShortDescription: single_product?.ShortDescription }} />
                                            </div>
                                        </div>
                                    </td>
                                    <td className="align-top">
                                        <span>{single_product.quantity}</span>
                                    </td>
                                    <td className="align-top">
                                        <span>{PRODUCT_PRICE.quantity}</span>
                                    </td>
                                    <td className="align-top">
                                        <span>{System.getFormatNumber({ amount: Number(PRODUCT_PRICE.marketPrice) })}</span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                {/* Modal footer */}
                <div className="modal-footer justify-content-center">
                    <div className="modal-footer-actions">
                        <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                            data-bs-toggle="modal"
                            onClick={() => { onHide(false) }}>
                            No
                            </button>
                        <button type="button" className="bs5 btn btn-primary btn-sm w145"
                            onClick={async () => { await updateQty() }}
                            data-bs-toggle="modal" >
                            Yes
                            </button>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default PriceMisMatch;